import React from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
} from '@carbon/react';

const CarbonTableComponent = ({ headers = [], rows }) => {
    return (
        <div style={{ width: '100%', height: '100%' }}>
            <Table size="lg" useZebraStyles={false} aria-label="Dynamic Table" style={{ width: '100%', height: '100%' }}>
                <TableHead>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableHeader key={index}>{header}</TableHeader>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => (
                        <TableRow key={row.id || rowIndex}>
                            {headers.map((_, colIndex) => (
                                <TableCell key={colIndex}>{row[colIndex]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default CarbonTableComponent;